import { ArrowLeft, Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

interface GeminiHeaderProps {
  title: string;
  subtitle?: string;
  showBack?: boolean;
  showMenu?: boolean;
  onMenuClick?: () => void;
  rightElement?: React.ReactNode;
  backPath?: string;
  useHistoryBack?: boolean;
}

export function GeminiHeader({ 
  title, 
  subtitle,
  showBack = true, 
  showMenu = false,
  onMenuClick,
  rightElement,
  backPath = '/home',
  useHistoryBack = false
}: GeminiHeaderProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (useHistoryBack) {
      navigate(-1);
    } else {
      navigate(backPath);
    }
  };

  return (
    <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border/50 pt-safe">
      <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {showBack && (
            <Button 
              variant="ghost" 
              size="icon" 
              onClick={handleBack} 
              className="h-10 w-10 rounded-full"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
          )}
          {showMenu && onMenuClick && (
            <Button 
              variant="ghost" 
              size="icon" 
              onClick={onMenuClick} 
              className="h-10 w-10 rounded-full"
            >
              <Menu className="h-5 w-5" />
            </Button>
          )}
          <div>
            <h1 className="font-bold text-lg">{title}</h1>
            {subtitle && (
              <p className="text-xs text-muted-foreground">{subtitle}</p>
            )}
          </div>
        </div>
        {rightElement && (
          <div className="flex items-center gap-2">
            {rightElement}
          </div>
        )}
      </div>
    </header>
  );
}
